window.skGaTranslate = window.skGaTranslate || {};

(function ($) {

    const init = () => {

        // Prep
        // -- Desktop toggle
        const englishHeaderLink = document.querySelector(".header-utilities a[href='/en/']");
        englishHeaderLink.classList.add("gt-language-switcher");

        // -- Mobile toggle
        const languageSwitcherLink = document.createElement("a");
        languageSwitcherLink.classList.add("gt-language-switcher");
        languageSwitcherLink.classList.add("hidden-sm");
        languageSwitcherLink.classList.add("hidden-md");
        languageSwitcherLink.classList.add("hidden-lg");
        const h1Node = document.querySelector("h1");
        h1Node.parentNode.insertBefore(languageSwitcherLink, h1Node);

        const translateElement = document.createElement("div");
        translateElement.id = "google_translate_element";
        translateElement.classList.add("google_translate_element");

        // Query elements
        const languageSwitchers = document.querySelectorAll(".gt-language-switcher");

        languageSwitchers.forEach(languageSwitcher => {

            languageSwitcher.innerHTML = "Change language";

            languageSwitcher.addEventListener("click", function (e) {
                e.preventDefault();

                languageSwitcher.parentNode.insertBefore(translateElement, languageSwitcher);

                const translateScript = document.createElement("script");
                translateScript.type = "text/javascript";
                translateScript.src = "https://translate.google.com/translate_a/element.js?cb=skGaTranslate.elementInit";
                document.head.appendChild(translateScript);
                eval(translateScript);

                translateElement.classList.toggle("google_translate_element--visible");
                languageSwitcher.classList.toggle("hidden");
            });

        });

        if (window.location.hash.includes("#gt-")) {
            // There is a language code predefined for google translate
            let langCode = window.location.hash.replace("#gt-", "");

            // Initialize google translate
            $(".gt-language-switcher:visible")[0].click();

            const interval = setInterval(function () {
                // Wait for google translate to be initialized
                if (skGaTranslate.translateElement !== undefined) {
                    clearInterval(interval);

                    // Update select box and fire event to trigger translation
                    const gObj = $(".goog-te-combo");
                    const selectList = gObj.get(0);
                    gObj.val(langCode);
                    fireChangeEvent(selectList);
                }
            }, 500);
        }

        function fireChangeEvent(el) {
            let evt;
            if (document.createEventObject) {
                //for IE
                evt = document.createEventObject();
                return el.fireEvent("on" + "change", evt);
            } else {
                // For other browsers
                evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", true, true);
                return !el.dispatchEvent(evt);
            }
        }

        // Update url when language is changed
        $("body").on("change", "#google_translate_element select", function (e) {
            const langCode = $(this).find(":selected").val();
            window.location.hash = "gt-" + langCode;
        });
    };

    skGaTranslate.elementInit = function () {
        skGaTranslate.translateElement = new google.translate.TranslateElement({
            pageLanguage: 'no',
            layout: google.translate.TranslateElement.InlineLayout.VERTICAL
        }, 'google_translate_element');
    };

    // If body contain data-ga-translate="activated", then init
    if (document.body.getAttribute("data-ga-translate") === "activated") {
        init();
    }

})(jQuery, skGaTranslate);
